import FilterInputText from "./FilterInputText";

export default FilterInputText;